import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import router from './router'
import store from './store'
import Print from 'vue-print-nb'
import 'font-awesome/css/font-awesome.min.css'
import '@/permission' // permission control
import VueAnimXYZ from '@animxyz/vue'
import '@animxyz/core'


Vue.use(ElementUI, {locale})
Vue.use(Print)
Vue.use(VueAnimXYZ)



Vue.config.productionTip = false
import api from '@/api'


Vue.prototype.$api = api



// Vue.prototype.$base64 = {
//   // 将普通字符串转换为Base64编码
//   encode(str) {
//     return window.btoa(str)
//   },
//   // 将Base64编码还原为普通字符串
//   decode(str) {
//     return window.atob(str)
//   }
// }

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})
